import useSystemStore from '~~/store/system'
import useUserStore from '~~/store/user'

export default defineNuxtPlugin(() => {
  // 获取默认语言参数
  const language = useCookie('language')
  const gwId = useCookie('gwId')
  const accessToken = useCookie('accessToken')
  const country = useCookie('country')
  const appVersion = useCookie('appVersion')
  const safeTop = useCookie('safeTop')
  const navBarH = useCookie('navBarH')
  const bottomSafeH = useCookie('bottomSafeH')
  const system = useCookie('system')

  const { SET_INFO, SET_IS_GEM, SET_IS_ANDROID } = useSystemStore()
  const { SET_USER_INFO } = useUserStore()
  SET_INFO({
    language: language.value,
    country: country.value,
    appVersion: Number(appVersion.value),
    navBarH: Number(navBarH.value),
    safeTop: Number(safeTop.value),
    bottomSafeH: Number(bottomSafeH.value),
    systemType: system.value === 'android' ? '1' : '2',
  })
  SET_USER_INFO({
    accessToken: accessToken.value,
    gwId: gwId.value,
    isUrl: false,
    phone: '',
    nick: '',
    countryCode: country.value,
    country: country.value,
  })
  SET_IS_GEM(!!appVersion.value)
  SET_IS_ANDROID(system.value)
})
